import React from 'react'

const ClusterMap = () => {
  return (
    <div>ClusterMap</div>
  )
}

export default ClusterMap